<template>
    <div class="filtros-extras">
        <b-collapse class="card" :open="false">
            <div slot="trigger" slot-scope="props" class="card-header is-paddingless">
                <div class="card-header-title">
                    <div class="filtro-header">
                        <b-icon :icon="props.open ? 'menu-down' : 'menu-right'"></b-icon>
                        {{ $t('filtros') }}
                    </div>
                </div>
            </div>
            <div class="card-content">
                <div class="columns is-multiline py-2">
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('tipo-pedido')" />
                        <s-select
                            :value="tipoPedidoSelecionados"
                            :options="tipoPedido"
                            :loading="tipoPedidoLoading"
                            @search="carregarTipoPedido"
                            @input="updateTipoPedido"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('ven-cliente-aba-formas-pgto')" />
                        <s-select
                            :value="formaPagamentoSelecionados"
                            :options="formaPagamento"
                            :loading="formaPagamentoLoading"
                            @search="carregarFormaPagamento"
                            @input="updateFormaPagamento"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('ven-cliente-aba-prazos-pgto')" />
                        <s-select
                            :value="prazoPagamentoSelecionados"
                            :options="prazoPagamento"
                            :loading="prazoPagamentoLoading"
                            @search="carregarPrazoPagamento"
                            @input="updatePrazoPagamento"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('tab-preco')" />
                        <s-select
                            :value="tabPrecoSelecionadas"
                            :options="tabPreco"
                            :loading="tabPrecoLoading"
                            @search="carregarTabPreco"
                            @input="updateTabPreco"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('transportadora')" />
                        <s-select
                            :value="transportadorasSelecionadas"
                            :options="transportadoras"
                            :loading="transportadorasLoading"
                            @search="carregarTransportadoras"
                            @input="updateTransportadora"
                            label="nome"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label for="busca" v-text="$t('tipo-de-frete')" />
                        <s-select
                            :value="tiposFreteSelecionados"
                            :options="tiposFrete"
                            :loading="tiposFreteLoading"
                            @search="carregarTiposFrete"
                            @input="updateTiposFrete"
                            label="descricao"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div
                        v-if="mostraFiltroEmpresa"
                        class="column is-one-third is-full-mobile card-content-top"
                    >
                        <label for="busca" v-text="$t('empresa')" />
                        <s-select
                            :value="empresasSelecionadas"
                            :options="empresas"
                            :loading="empresasLoading"
                            @search="carregarEmpresas"
                            @input="updateEmpresa"
                            label="rsocial"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div
                        v-if="mostraFiltroVendedor"
                        class="column is-one-third is-full-mobile card-content-top"
                    >
                        <label for="busca" v-text="$t('vendedor')" />
                        <!-- @84451 - Tooltip inserida no filtro de vendedores -->
                        <b-icon 
                            icon="information" 
                            size="is-small" 
                            v-tippy 
                            :title="$t('msg-filtros-vendedores')"
                        />
                        <s-select
                            :value="vendedoresSelecionados"
                            :options="vendedores"
                            :loading="vendedoresLoading"
                            @search="carregarVendedores"
                            @input="updateVendedor"
                            label="nome"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <vss-select
                            class="form-height"
                            label="description"
                            :options="statusLista"
                            :loading="statusLoading"
                            @input="onSituacaoStatus"
                            v-model="statusSelected"
                            title="status"
                            :onBlurFunction="alterValuesOrigemByStatus"
                            clearable
                        >
                            <template #selected="{ option }">
                                {{ option ? option.description : $t('todos') }}
                            </template>
                        </vss-select>
                    </div>
                    <!-- @84412 - Inserção do módulo de origem -->
                    <div class="column is-one-third is-full-mobile card-content-top">
                        <label v-text="$t('origem')" />
                        <vss-select
                            class="form-height"
                            label="label"
                            :options="origemLista"
                            :loading="origemLoading"
                            @input="onSituacaoOrigem"
                            v-model="origem"
                            :onBlurFunction="alterValuesStatusByOrigem"
                        />
                    </div>
                    <div
                        class="column is-one-third is-full-mobile card-content-top"
                    >
                        <label for="busca" v-text="$t('motivo-origem')" />
                        <s-select
                            :value="origemMotivoSelecionados"
                            :options="origemMotivoLista"
                            :loading="origemMotivoLoading"
                            @search="loadOrigensMotivo"
                            @input="updateOrigemMotivo"
                            label="rsocial"
                            multiple
                            searchable
                            clearable
                        />
                    </div>
                </div>
            </div>
        </b-collapse>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import TabPrecoService from '@/services/vendas/tabpreco/TabPrecoService';
import TipoPedidoService from '@/services/vendas/TipoPedidoService';
import FormaPagtoService from '@/services/FormaPagtoService';
import PrazoPagtoService from '@/services/vendas/prazopagto/PrazoPagtoService';
import TransportadoraService from '@/services/vendas/TransportadoraService';
import TipoFreteService from '@/services/TipoFreteService';
import GerenciarUsuariosService from '@/services/conta/GerenciarUsuariosService';
import PedidoService from '@/services/PedidoService';

export default {
    data() {
        return {
            statusLista: [],
            statusListaCompleta: [], // onde armazena todos os registros.
            statusSelected: null,
            statusLoading: false,
            empresaService: new EmpresaService(this.$http, this.$router),
            tabPrecoService: new TabPrecoService(this.$http, this.$router),
            tipoPedidoService: new TipoPedidoService(this.$http, this.$router),
            formaPagtoService: new FormaPagtoService(this.$http, this.$router),
            prazoPagtoService: new PrazoPagtoService(this.$http, this.$router),
            transportadoraService: new TransportadoraService(this.$http, this.$router),
            tipoFreteService: new TipoFreteService(this.$http, this.$router),
            colaboradorService: new GerenciarUsuariosService(this.$http, this.$router), // vendedor
            pedidoService: new PedidoService(this.$http, this.$router),
            // motivoService: new MotivoService(this.$http, this.$router),

            contagem: { label: 'todos', value: '' },
            situacoesContagem: [
                { label: 'todos', value: '' },
                { label: 'sim', value: 1 },
                { label: 'nao', value: 0 },
            ],
            empresas: [],
            empresasSelecionadas: [],
            empresasLoading: false,
            mostraFiltroEmpresa: false,
            tabPreco: [],
            tabPrecoSelecionadas: [],
            tabPrecoLoading: false,
            tipoPedido: [],
            tipoPedidoSelecionados: [],
            tipoPedidoLoading: false,
            formaPagamento: [],
            formaPagamentoSelecionados: [],
            formaPagamentoLoading: false,
            prazoPagamento: [],
            prazoPagamentoSelecionados: [],
            prazoPagamentoLoading: false,
            origemMotivoSelecionados: [],
            transportadoras: [],
            transportadorasSelecionadas: [],
            transportadorasLoading: false,
            tiposFrete: [],
            tiposFreteSelecionados: [],
            tiposFreteLoading: false,
            vendedores: [],
            vendedoresSelecionados: [],
            vendedoresLoading: false,
            mostraFiltroVendedor: false,
            // @84412 - Adição das infos relacionadas a origem
            origem: { id: 0, label: this.$t('todos').toUpperCase() },
            motivoOrigem: this.$t('todos').toUpperCase(),
            origemLista: [],
            origemListaCompleta: [], // para armazenar os registros completos
            origemMotivoLista: [],
            origemMotivoListaCompleta: [],
            origemLoading: false,
            origemMotivoLoading: false
        };
    },
    created() {
        this.carregarEmpresas('');
        this.carregarVendedores('');
        this.loadOrigensPedido();
        this.loadOrigensMotivo();
        this.carregarDadosStatus();
    },
    methods: {
        limparFiltrosSelecionados() {
            this.empresasSelecionadas = [];
            this.tabPrecoSelecionadas = [];
            this.tipoPedidoSelecionados = [];
            this.formaPagamentoSelecionados = [];
            this.prazoPagamentoSelecionados = [];
            this.transportadorasSelecionadas = [];
            this.tiposFreteSelecionados = [];
            this.vendedoresSelecionados = [];
            this.statusSelected = null;
            this.origem = this.origemLista[0];
            this.motivoOrigem = this.origemMotivoLista[0];
            this.origemMotivoSelecionados = [];
            this.fil = [];
        },
        onSituacaoStatus(val) {
            let temp = null;
            if (val) {
                temp = this.statusLista.filter((v) => v.id == val.id);
                this.statusSelected = temp[0];
            } else {
                this.statusSelected = null;
            }
            this.$emit('update-filtro', {
                nomeFiltro: 'status',
                valor: this.statusSelected,
            });
        },
        /*
        @84626
        retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
        retorna todas as empresas
    */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[PEDIDO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[PEDIDO] Mensagem: ${r.message}`);
                    } else {
                        this.empresas = r.content;
                    }
                })
                .catch((e) => {
                    console.error('[PEDIDO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    if (this.empresas.length > 0) {
                        this.mostraFiltroEmpresa = true;
                    }
                    this.empresasLoading = false;
                });
        },
        updateEmpresa(e) {
            this.empresasSelecionadas = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'empresas',
                valor: e,
            });
        },
        updateOrigemMotivo(e){
            this.origemMotivoSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'motivo-origem',
                valor: e,
            });
        },
        // TABELA DE PRECO
        carregarTabPreco(q) {
            this.tabPrecoLoading = true;
            this.tabPrecoService
                .findAll('datahorainc', 'desc', 0, 20, q)
                .then((r) => {
                    this.tabPreco = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de tabela de preços. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.tabPrecoLoading = false;
                });
        },
        updateTabPreco(e) {
            this.tabPrecoSelecionadas = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'tabelaPreco',
                valor: e,
            });
        },
        // TIPO DE PEDIDO
        carregarTipoPedido(q) {
            this.tipoPedidoLoading = true;
            this.tipoPedidoService
                .findAllFiltroPedido('datahorainc', 'desc', 0, 20, q)
                .then((r) => {
                    this.tipoPedido = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa tipo de pedido. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.tipoPedidoLoading = false;
                });
        },
        updateTipoPedido(e) {
            this.tipoPedidoSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'tiposPedido',
                valor: e,
            });
        },
        // FORMA DE PAGAMENTO
        carregarFormaPagamento(q) {
            this.formaPagamentoLoading = true;
            this.formaPagtoService
                .findAllOld('datahorainc', 'desc', 0, 20, q)
                .then((r) => {
                    this.formaPagamento = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de formas de pagamento. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.formaPagamentoLoading = false;
                });
        },
        updateFormaPagamento(e) {
            this.formaPagamentoSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'formas-pagamento',
                valor: e,
            });
        },
        // PRAZO DE PAGAMENTO
        carregarPrazoPagamento(q) {
            this.prazoPagamentoLoading = true;
            this.prazoPagtoService
                .findAllHasOrder('datahorainc', 'desc', 0, 20, q)
                .then((r) => {
                    this.prazoPagamento = r.content;
                })
                .catch((e) => {
                    console.error(
                        `Erro ao realizar pesquisa de prazos de pagamento. Termo: [${q}]`,
                        e
                    );
                })
                .finally((_) => {
                    this.prazoPagamentoLoading = false;
                });
        },
        updatePrazoPagamento(e) {
            this.prazoPagamentoSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'prazosPagamento',
                valor: e,
            });
        },
        // TRANSPORTADORA
        carregarTransportadoras(q) {
            this.transportadorasLoading = true;
            this.transportadoraService
                .findAllOld(0, 20, q)
                .then((r) => {
                    this.transportadoras = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de transportadoras. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.transportadorasLoading = false;
                });
        },
        updateTransportadora(e) {
            this.transportadorasSelecionadas = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'transportadoras',
                valor: e,
            });
        },
        // TIPO FRETE
        carregarTiposFrete(q) {
            this.tiposFreteLoading = true;
            this.tipoFreteService
                .findAll(0, 20, q)
                .then((r) => {
                    this.tiposFrete = r.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de tipos de frete. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.tiposFreteLoading = false;
                });
        },
        updateTiposFrete(e) {
            this.tiposFreteSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'tiposFrete',
                valor: e,
            });
        },
        // VENDEDOR
        carregarVendedores(q) {
            this.vendedoresLoading = true;
            q = this.isNull(q) ? '' : this.removeToSearch(q);

            this.colaboradorService
                .findAllComboSituacao(1, q)
                .then((r) => {
                    this.vendedores = r.content;
                    if (this.vendedores.length > 1) {
                        this.mostraFiltroVendedor = true;
                    }
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa de vendedores. Termo: [${q}]`, e);
                })
                .finally((_) => {
                    this.vendedoresLoading = false;
                });
        },
        updateVendedor(e) {
            this.vendedoresSelecionados = e;
            this.$emit('update-filtro', {
                nomeFiltro: 'vendedores',
                valor: e,
            });
        },
        // ORIGEM -- @84412 - Update do filtro com base nos valores inseridos para origem
        onSituacaoOrigem(val) {
            let temp = null;
            if (val) {
                temp = this.origemLista.filter((v) => v.id == val.id);
                this.origem = temp[0];
            } else {
                this.origem = this.origemLista[0];
            }
            this.$emit('update-filtro', {
                nomeFiltro: 'origem',
                valor: this.origem.id,
            });
        },
        // @84601 carrega as origens
        loadOrigensPedido() {
            this.origemLoading = true;

            this.pedidoService
                .getOrigensPedidoCombo()
                .then((r) => {
                    this.origemListaCompleta.push(this.origem);
                    Object.entries(r.content).forEach(([key, val]) => {
                        this.origemListaCompleta.push({ id: key, label: val.toUpperCase() });
                    });
                    this.origemLista = Object.assign([], this.origemListaCompleta);
                })
                .catch((e) => {
                    console.error('Erro ao carregar as origens.', e);
                })
                .finally((_) => {
                    this.origemLoading = false;
                });
        },
        loadOrigensMotivo() {
            this.origemMotivoLoading = true;
            // para carregar a listagem da origem no cadastro
            this.service
            this.$axios
                .get(`/agro/motivo/origens.json`)
                .then((r) => {
                    this.origemMotivoLista = r.data.content;
                })
                .catch((e) => {
                    console.error(`Erro ao realizar pesquisa por origens.`, e);
                })
                .finally(() => {
                    this.origemMotivoLoading = false;
                });

        },
        carregarDadosStatus() {
            this.statusLoading = true;

            this.$axios
                .get(`/ven/pedido/status/getcombo.json`)
                .then((response) => {
                    let count = 1;
                    this.statusListaCompleta = response.data.content.map((item) => {
                        return {
                            ...item,
                            id: count++,
                        };
                    });
                    this.statusLista = Object.assign([], this.statusListaCompleta);
                })
                .catch(() => {
                    this.statusListaCompleta = [];
                    this.statusLista = [];
                })
                .finally(() => {
                    this.statusLoading = false;
                });
        },
        // @84601 - carrega os status conforme a origem, se é do sistema, carrega os status do sistema e vice versa.
        alterValuesStatusByOrigem() {
            if (this.origem.id > 0) {
                this.statusLista = this.statusListaCompleta.filter((item) => item.tableName == 'STATUSWF');
            } else if (this.origem.id < 0) {
                this.statusLista = this.statusListaCompleta.filter((item) => item.tableName == 'PED_SITUACAO');
            } else {
                this.statusLista = Object.assign([], this.statusListaCompleta);
            }
        },
        // @84601 - carrega as origens conforme o status, se é do sistema, carrega as origens do sistema e vice versa.
        alterValuesOrigemByStatus() {
            this.origemLista = Object.assign([], this.origemListaCompleta);
            if(this.statusSelected == null){
                return;
            } else if (this.statusSelected.tableName == 'STATUSWF') {
                this.origemLista = this.origemLista.filter((item) => item.id >= 0);
            } else if (this.statusSelected.tableName == 'PED_SITUACAO') {
                this.origemLista = this.origemLista.filter((item) => item.id <= 0);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.card {
    overflow: initial;
    color: $darker-gray-color;
    .card-header-title {
        color: $darker-gray-color;
        justify-content: space-between;
        padding: 0.3rem;
    }

    .card-content {
        padding: 0.9rem;

        .card-content-top {
            padding-top: 0.25rem;
            padding-bottom: 0.25rem;
        }
    }
}

.filtro-header {
    display: flex;
    align-items: center;
}

.filtros-extras {
    font-size: 12px;
}
.form-height {
    height: 34px;
}
</style>
